"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _semanticUiReact = require("semantic-ui-react");

var _LeftPaneWrapper = _interopRequireDefault(require("./LeftPaneWrapper"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var CentralPaneWrapper = function CentralPaneWrapper(_ref) {
  var _ref$isMobile = _ref.isMobile,
      isMobile = _ref$isMobile === void 0 ? false : _ref$isMobile,
      children = _ref.children;
  return /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      marginLeft: 'auto',
      marginRight: 'auto',
      marginTop: '5vh',
      width: isMobile ? '100%' : '80%',
      maxWidth: _semanticUiReact.Responsive.onlyTablet.maxWidth,
      height: isMobile ? '100%' : undefined
    }
  }, /*#__PURE__*/_react["default"].createElement(_LeftPaneWrapper["default"], {
    fullHeight: isMobile,
    noSidePadding: isMobile
  }, children));
};

var _default = CentralPaneWrapper;
exports["default"] = _default;